import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Map } from 'lucide-react';
import { sitemapLinkService } from '../services/api';

function Sitemap() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        const response = await sitemapLinkService.getAll();
        if (response.data) {
          const grouped = response.data.reduce((acc, link) => {
            const existing = acc.find(s => s.title === link.category);
            if (existing) {
              existing.links.push({ label: link.label, path: link.path });
            } else {
              acc.push({
                title: link.category,
                links: [{ label: link.label, path: link.path }],
              });
            }
            return acc;
          }, []);
          setSections(grouped);
        }
      } catch (error) {
        console.error('Error fetching sitemap:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSitemap();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4 flex items-center gap-3">
            <Map size={40} />
            نقشه سایت
          </h1>
          <p className="text-xl text-blue-100">تمام صفحات و بخش‌های سایت</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {sections.length ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sections.map((section, idx) => (
              <div key={idx} className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-lg font-bold text-gray-900 mb-4 pb-3 border-b-2 border-blue-700">
                  {section.title}
                </h2>
                <ul className="space-y-2">
                  {section.links.map((link, linkIdx) => (
                    <li key={linkIdx}>
                      <Link
                        to={link.path}
                        className="text-blue-700 hover:text-blue-900 hover:underline transition"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-md p-8 text-center text-gray-500">
            <p>اطلاعاتی برای نمایش وجود ندارد</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sitemap;
